import React, { useEffect, useContext, useState } from "react";
import "./OwnerInfos.scss";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NumberFormat from "react-number-format";
import { Link, NavLink } from "react-router-dom";

import { UserContext } from "../../api/user/userContext";
import DeleteDialog from "./DeleteDialog";
import { Avatars, slug } from "../../api/ReplayVariables";
import i18n from "i18next";

function OwnerInfos({
  history,
  hand,
  onSubscribed,
  onShowLogin,
  onVisibility,
  homepage = false
}) {
  const [showDelete, setShowDelete] = useState(false);

  const onReplayDeleted = () => {
    setShowDelete(false);
    history.push("/c/" + slug(user.username) + "-" + user.id + "/replays");
  };

  const { user } = useContext(UserContext);
  const { t } = useTranslation();

  const deleteReplay = () => {
    window.stop();
    setShowDelete(true);
  };

  const toggleSubscription = () => {
    if (user !== null && user.id > 0) {
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body:
          "id=" +
          hand.user_id +
          "&id_slug=" +
          slug(hand.user_name) +
          "&my_slug=" +
          slug(user.username) +
          "&lng=" +
          i18n.language +
          "&subscribed=" +
          !hand.subscribed
      };
      fetch(window.serverUrl+`/social/subscribe.php`, requestOptions)
        .then((r) => r.json())
        .then((resp) => {
          console.log("resp", resp);

          onSubscribed(resp);
        })
        .catch((err) => {
          console.error("fetch problem", err);
        });
    } else {
      //show login
      console.log("login!");
      onShowLogin();
    }
  };

  const toggleVisibility = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: "id=" + hand.id + "&visibility=" + (hand.visibility === 1 ? 0 : 1)
    };
    fetch(window.serverUrl+`/social/visibility.php`, requestOptions)
      .then((r) => r.json())
      .then((resp) => {
        console.log("resp", resp);
        onVisibility(resp.visibility);
      })
      .catch((err) => {
        console.error("fetch problem", err);
      });
  };

  useEffect(() => {
    return () => {};
  }, [user]);
  return (
    <>
      <div className="owner-infos d-flex flex-column">
        <div className="owner d-flex flex-row align-items-center">
          <Link
            to={"/c/" + slug(hand.user_name) + "-" + hand.user_id + "/home"}
            className="owner-details-container d-flex flex-row"
          >
            {hand.user_avatar ? (
              <img
                className="avatar-image"
                src={
                  window.serverUrl+"/media/kunena/avatars/" +
                  hand.user_avatar
                }
                alt="avatar"
              />
            ) : (
              <img
                className="avatar"
                src={
                  Avatars[
                    "avatar" + hand.user_name.substring(0, 1).toUpperCase()
                  ]
                }
                alt=""
              />
            )}

            <div className="owner-details d-flex flex-column">
              <div className="name">{hand.user_name}</div>
              <div className="subscribers">
                <NumberFormat
                  value={hand.subscribers}
                  displayType={"text"}
                  thousandSeparator={true}
                  renderText={(value) => <>{value}</>}
                />{" "}
                {t(
                  hand.subscribers > 1
                    ? "replayApp.subscribers"
                    : "replayApp.subscriber"
                )}
              </div>
              <div className="replays">
                <NumberFormat
                  value={hand.user_replays}
                  displayType={"text"}
                  thousandSeparator={true}
                  renderText={(value) => <>{value}</>}
                />{" "}
                {t(
                  hand.user_replays > 1
                    ? "replayApp.user_replays"
                    : "replayApp.user_replay"
                )}
              </div>
            </div>
          </Link>
          {homepage ? (
            <NavLink className="ml-auto" to={"/w/" + hand.id}>
              <Button className="subscribe">{t("landing.openHand")}</Button>
            </NavLink>
          ) : user !== null && user.id !== hand.user_id ? (
            <Button className="subscribe" onClick={toggleSubscription}>
              {t(
                hand.subscribed && user.error !== 401
                  ? "replayApp.unsubscribe"
                  : "replayApp.subscribe"
              )}
            </Button>
          ) : (
            <div className="replay-actions flex-row">
              <Button
                className="visibility flex-row align-items-center"
                data-tip={
                  t("replayApp.visibility.switch") +
                  " " +
                  (hand.visibility === 1
                    ? t("replayApp.visibility.private")
                    : t("replayApp.visibility.public"))
                }
                data-for="app-tooltip"
                onClick={toggleVisibility}
              >
                {hand.visibility === 1 ? (
                  <>
                    <Eye size="18"></Eye>&nbsp;
                    {t("replayApp.visibility.public")}
                  </>
                ) : (
                  <>
                    <EyeSlash size="18"></EyeSlash>&nbsp;
                    {t("replayApp.visibility.private")}
                  </>
                )}
              </Button>
              <Button className="delete" onClick={deleteReplay}>
                {t("replayApp.deleteReplay")}
              </Button>
            </div>
          )}
        </div>
        <div className="description"></div>
      </div>
      <DeleteDialog
        show={showDelete}
        replayId={hand.id}
        handleClose={() => {
          setShowDelete(false);
        }}
        onDeleted={onReplayDeleted}
      ></DeleteDialog>
    </>
  );
}

export default OwnerInfos;
